import { useEffect, useRef } from 'react'

/**
 * @see https://ahooks.js.org/hooks/use-update-effect/
 */
const useUpdateEffect = (effect, deps) => {
    const isMounted = useRef(false);

    // for react-refresh
    useEffect(() => {
      return () => {
        isMounted.current = false;
      };
    }, []);

    useEffect(() => {
      if (!isMounted.current) {
        isMounted.current = true;
      } else {
        return effect();
      }
    }, deps);
};

export default useUpdateEffect